<template>
    <div class="login">


        <b-row align-v="center" align-h="center">
            <b-col md="5">

                <LoginWindow />

            </b-col>

        </b-row>


    </div>
</template>


<script>

import LoginWindow from '@/components/LoginWindow.vue'

export default {
    name: 'Login',
    components: {
        LoginWindow
    },
    data() {
        return {
        }
    },
    methods: {
        loginRedirect() {
            this.$router.push('/logginn');
        }
    }
}
</script>



<style scoped lang="scss">


.errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}

</style>
